module.exports = __webpack_public_path__ + "img/bubble-background-chystam-party-mobile.b3e5011.svg";